//* 组件库
import type { UiTypes } from "various-ui";
//* 组件属性
import type { ModuleProps, ModuleData } from "../index";
import { useOptions } from "./options";

export const useComposable = (define: ModuleProps) => {
    //* 插件
    const route = useRoute();
    //* 配置项
    const options = useOptions();

    //* 响应式属性
    const refs = {
        loading: ref<boolean>(true), //* 内置加载器
        exist: ref<boolean>(true), //* 页面状态配置
        count: ref<number>(0),
        page: ref<number>(1),
        data: ref<ModuleData[]>([]),
        sort: reactive({ key: "", value: "" }),

        //* 筛选项
        filters: ref<UiTypes.candidate[]>([]),
        classifications: ref<string[]>([]),
        classification: ref<boolean>(false),
    };

    //* 节点
    const nodes = {
        container: ref<HTMLDivElement>(),
    };

    //* 函数列表
    const methods = {
        //* 数据获取函数
        acquire: (number?: number, scroll?: boolean) => {
            //* 状态更新
            refs.loading.value = true;
            refs.page.value = number || refs.page.value;

            //* 排序初始化
            let sort = refs.sort.value == "desc" ? "-" : "";
            if (refs.sort.key == "mutation_number") {
                sort += "mutation_qty";
            } else if (refs.sort.key == "source") {
                sort += "score";
            }

            //TODO 待完善
            let mode = define.mode == "gene" ? "disease" : "gene";

            //* 接口请求
            api.frontend("/api/related/mutations", {
                method: "POST",
                data: {
                    id: define.id,
                    mode: mode,
                    page: refs.page.value,
                    classify: refs.classifications.value || [],
                    sort: sort ? [sort] : [],
                },
                error: () => methods.hidden(),
                success: (response) => {
                    if (!response) {
                        methods.hidden();
                    } else {
                        refs.loading.value = false;
                        //* 数据更新
                        refs.filters.value = response?.filters || [];
                        refs.data.value = response?.data || [];
                        refs.count.value = response?.count || 0;
                        //* 位置移动
                        if (nodes.container.value && !scroll) {
                            scrollTo({ top: nodes.container.value.offsetTop - 280, behavior: "smooth" });
                        }
                    }
                },
            });
        },

        hidden: () => {
            refs.exist.value = false;
            refs.loading.value = false;
        },

        route: (id: string) => {
            switch (define.mode) {
                case "gene":
                    return { genes: id, diseases: route.params.id };
                case "disease":
                    return { genes: route.params.id, diseases: id };
                default:
                    return {};
            }
        },

        //* 排序函数
        sort: (data: { key: string; value: string }) => {
            //* 数据初始化
            refs.sort.key = data?.key || "";
            refs.sort.value = data?.value || "";
            //* 数据获取
            methods.acquire(1);
        },

        //* 选择回调
        classifications: () => {
            //* 数据更新
            refs.classification.value = refs.classifications.value.length == refs.filters.value.length;
            //* 数据获取
            methods.acquire(1);
        },

        //* 全选回调
        classification: () => {
            //* 数据更新
            if (refs.classification.value) {
                refs.classifications.value = [];
                refs.filters.value.forEach((value) => {
                    refs.classifications.value.push(value.value);
                });
            } else {
                refs.classifications.value = [];
            }

            //* 数据获取
            methods.acquire(1);
        },
    };

    //* 计算属性
    const computeds = {
        option: computed(() => {
            if (define.mode == "gene") return options.gene;
            else {
                return options.disease;
            }
        }),
    };

    return { refs, nodes, methods, computeds };
};
